import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { IProduct } from '../types/products';

interface IProductGrid {
  products: IProduct[];
  showId?: boolean;
  productPage?: boolean;
  translateSlug?: boolean;
}

export const Products: React.FC<IProductGrid> = ({
  products,
  showId = false,
  productPage = false,
  translateSlug = false,
}) => {
  const router = useRouter();
  const { locale } = router;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {products.map((product) => {
        const slug =
          locale !== 'en' && translateSlug
            ? product?.helpers?.slug
            : product?.slug;
        const featuredImage = product.featuredImage?.node.sourceUrl
          ? product.featuredImage?.node.sourceUrl
          : product.pl?.featuredImage?.node.sourceUrl
          ? product.pl?.featuredImage?.node.sourceUrl
          : '/img/product-empty.jpg';
        return (
          <div key={product.id}>
            <Link
              href={
                productPage
                  ? `${router.asPath.slice(
                      0,
                      router.asPath.lastIndexOf('/')
                    )}/${slug}-${product.databaseId}`
                  : `${router.asPath}/${slug}${
                      showId ? `-${product.databaseId}` : ''
                    }`
              }
              passHref
              prefetch={false}
            >
              <div
                className={`relative overflow-hidden ${
                  (product.featuredImage?.node.sourceUrl ||
                    product.pl?.featuredImage?.node.sourceUrl) ??
                  'grayscale hover:grayscale-0 transform transition duration-500 ease-in-out'
                }`}
              >
                <Image
                  src={featuredImage}
                  alt={product.title}
                  width={
                    product.featuredImage?.node.mediaDetails.width
                      ? product.featuredImage?.node.mediaDetails.width
                      : product.pl?.featuredImage?.node.mediaDetails.width
                      ? product.pl?.featuredImage?.node.mediaDetails.width
                      : '459'
                  }
                  height={
                    product.featuredImage?.node.mediaDetails.width
                      ? product.featuredImage?.node.mediaDetails.width
                      : product.pl?.featuredImage?.node.mediaDetails.width
                      ? product.pl?.featuredImage?.node.mediaDetails.width
                      : '320'
                  }
                  className="hover:scale-110 hover:opacity-95 hover:cursor-pointer transform transition duration-300 ease-in-out min-h-full mx-auto"
                />
                {/* <div className="opacity-0 hover:opacity-100 hover:cursor-pointer duration-300 absolute inset-0 z-10 flex justify-center items-center text-6xl text-white font-semibold">
                  SVG icon
                </div> */}
              </div>
            </Link>
            <div className="text-xl p-1 bg-gradient-to-r from-red to-orange text-white font-bold">
              <Link
                href={
                  productPage
                    ? `${router.asPath.slice(
                        0,
                        router.asPath.lastIndexOf('/')
                      )}/${slug}-${product.databaseId}`
                    : `${router.asPath}/${slug}${
                        showId ? `-${product.databaseId}` : ''
                      }`
                }
                passHref
                prefetch={false}
              >
                {product.title}
              </Link>
            </div>
          </div>
        );
      })}
    </div>
  );
};
